module.exports = __webpack_public_path__ + "static/media/plus.8ceda843.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/plus.png
// module id = 136
// module chunks = 1